import axios from 'axios';
import URLS from '../util/urls.js';

const state = {
  imoveis: []
}

const mutations = {
  atualizarImoveis(state, payload) {
    state.imoveis = payload;
  }
}

const actions = {
  recuperarImoveisMapa(context) {
    return axios.get(URLS.DASHBOARD_LISTAR_IMOVEIS_MAPA)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImoveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarImoveisMapa');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  }   
}

export default {
  state,
  mutations,
  actions
}